// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.properties-head {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
.properties-head h3 {
  margin: 5px;
}
.properties-head h1 {
  color: grey;
  font-size: 18px;
}

mat-divider {
  margin-top: 9.5px;
  margin-bottom: 7px;
}

.input-errors {
  color: red;
}

::ng-deep .head-properties .mat-form-field {
  font-size: 20px;
}
::ng-deep .head-properties .mat-form-field mat-error div {
  width: auto;
  border-style: solid;
  border-radius: 5px;
  background: #b71c1c;
  color: white;
  margin-top: 4px;
}

input.mat-input-element {
  color: gray;
  font-weight: normal;
}

fieldset {
  width: 99.3%;
}
fieldset .mat-radio-label {
  color: grey;
}
fieldset span p {
  margin: 5px 10px 4px 10px;
}
fieldset legend {
  font-size: 11px;
}

.choice-control-properties,
.radio-control-properties,
.textbox-control-properties,
.number-control-properties,
.date-control-properties,
.email-control-properties,
.website-control-properties,
.phone-control-properties,
.currency-control-properties,
.signature-control-properties,
.name-control-properties,
.address-control-properties,
.upload-control-properties {
  display: flex;
  flex-direction: column;
}

.type-radio {
  display: flex;
  font-size: 14px;
  flex-direction: column;
}
.type-radio .mat-radio-button {
  margin: 0px 0px 5px 5px;
}
.type-radio .mat-radio-button:last-child {
  margin-bottom: 0px !important;
}

.field-set-type, .field-set-type-options {
  border: 1px solid rgb(211, 211, 211);
  font-size: 14px;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  margin-bottom: 5px;
}
.field-set-type legend, .field-set-type-options legend {
  font-weight: bold;
  color: gray;
}
.field-set-type span, .field-set-type-options span {
  display: flex;
  align-items: center;
  justify-content: space-between;
  word-break: break-all;
}

.eform-btn-actions {
  border-radius: 5px;
}

.eform-btn-actions-first {
  border-radius: 5px 0px 0px 5px;
}

.eform-btn-actions-mid {
  border-radius: 0px 0px 0px 0px;
}

.eform-btn-actions-last {
  border-radius: 0px 5px 5px 0px;
}

.field-option {
  width: 255px;
}

.field-set {
  border-color: red;
}

.margin-left-5 {
  margin-left: 5px;
}

.margin-left-10 {
  margin-left: 10px;
}

.margin-left-15 {
  margin-left: 15px;
}

.margin-left-25 {
  margin-left: 25px;
}`, "",{"version":3,"sources":["webpack://./src/app/e-form/form-control/properties/_properties-theme.scss","webpack://./src/app/e-form/form-control/properties/phone-properties/phone-properties.component.scss"],"names":[],"mappings":"AAUA;EACG,aAAA;EACA,uBAAA;EACA,eAAA;ACTH;ADWG;EACG,WAAA;ACTN;ADYG;EACG,WAAA;EACA,eAAA;ACVN;;ADcA;EACG,iBAAA;EACA,kBAAA;ACXH;;ADcA;EACG,UAAA;ACXH;;ADcA;EACG,eAAA;ACXH;ADcM;EACG,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;ACZT;;ADiBA;EACG,WAAA;EACA,mBAAA;ACdH;;ADiBA;EACG,YAAA;ACdH;ADeG;EACG,WAAA;ACbN;ADiBM;EACG,yBAAA;ACfT;ADmBG;EACG,eAAA;ACjBN;;ADqBA;;;;;;;;;;;;;EAcG,aAAA;EACA,sBAAA;ACnBH;;ADsBA;EACG,aAAA;EACA,eAAA;EACA,sBAAA;ACnBH;ADqBG;EACG,uBAAA;ACnBN;ADqBG;EACG,6BAAA;ACnBN;;ADuBA;EACG,oCAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;ACpBH;ADsBG;EACG,iBAAA;EACA,WAAA;ACpBN;ADuBG;EACG,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,qBAAA;ACrBN;;ADyBA;EACG,kBAAA;ACtBH;;ADyBA;EACG,8BAAA;ACtBH;;ADyBA;EACG,8BAAA;ACtBH;;ADyBA;EACG,8BAAA;ACtBH;;ADyBA;EACG,YAAA;ACtBH;;ADyBA;EACE,iBAAA;ACtBF;;ADyBA;EACG,gBAAA;ACtBH;;ADyBA;EACG,iBAAA;ACtBH;;ADyBA;EACG,iBAAA;ACtBH;;ADyBA;EACG,iBAAA;ACtBH","sourcesContent":["@import \"@angular/material\";\n\n@mixin eform-properties-theme($theme) {\n   $primary: map-get($theme, primary);\n   $accent: map-get($theme, accent);\n   $warn: map-get($theme, warn);\n   $background: map-get($theme, background);\n   $foreground: map-get($theme, foreground);\n}\n\n.properties-head {\n   display: flex;\n   justify-content: center;\n   flex-wrap: wrap;\n\n   h3 {\n      margin: 5px;\n   }\n\n   h1 {\n      color: grey;\n      font-size: 18px;\n   }\n}\n\nmat-divider {\n   margin-top: 9.5px;\n   margin-bottom: 7px;\n}\n\n.input-errors {\n   color: red;\n}\n\n::ng-deep .head-properties .mat-form-field {\n   font-size: 20px;\n\n   mat-error {\n      div {\n         width: auto;\n         border-style: solid;\n         border-radius: 5px;\n         background: #b71c1c;\n         color: white;\n         margin-top: 4px;\n      }\n   }\n}\n\ninput.mat-input-element {\n   color: gray;\n   font-weight: normal;\n}\n\nfieldset {\n   width: 99.3%;\n   .mat-radio-label {\n      color: grey;\n   }\n\n   span {\n      p {\n         margin: 5px 10px 4px 10px;\n      }\n   }\n\n   legend {\n      font-size: 11px;\n   }\n}\n\n.choice-control-properties,\n.radio-control-properties,\n.textbox-control-properties,\n.number-control-properties,\n.date-control-properties,\n.email-control-properties,\n.website-control-properties,\n.phone-control-properties,\n.currency-control-properties,\n.signature-control-properties,\n.name-control-properties,\n.address-control-properties,\n.upload-control-properties\n {\n   display: flex;\n   flex-direction: column;\n}\n\n.type-radio {\n   display: flex;\n   font-size: 14px;\n   flex-direction: column;\n\n   .mat-radio-button {\n      margin: 0px 0px 5px 5px;\n   }\n   .mat-radio-button:last-child {\n      margin-bottom: 0px !important;\n   }\n}\n\n.field-set-type, .field-set-type-options {\n   border: 1px solid rgb(211, 211, 211);\n   font-size: 14px;\n   border-radius: 5px;\n   display: flex;\n   flex-direction: column;\n   margin-bottom: 5px;\n\n   legend {\n      font-weight: bold;\n      color: gray;\n   }\n\n   span {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      word-break: break-all;\n   }\n}\n\n.eform-btn-actions {\n   border-radius: 5px;\n}\n\n.eform-btn-actions-first {\n   border-radius: 5px 0px 0px 5px;\n}\n\n.eform-btn-actions-mid {\n   border-radius: 0px 0px 0px 0px;\n}\n\n.eform-btn-actions-last {\n   border-radius: 0px 5px 5px 0px;\n}\n\n.field-option {\n   width: 255px;\n}\n\n.field-set {\n  border-color: red;\n}\n\n.margin-left-5 {\n   margin-left: 5px;\n}\n\n.margin-left-10 {\n   margin-left: 10px;\n}\n\n.margin-left-15 {\n   margin-left: 15px;\n}\n\n.margin-left-25 {\n   margin-left: 25px;\n}\n",".properties-head {\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n.properties-head h3 {\n  margin: 5px;\n}\n.properties-head h1 {\n  color: grey;\n  font-size: 18px;\n}\n\nmat-divider {\n  margin-top: 9.5px;\n  margin-bottom: 7px;\n}\n\n.input-errors {\n  color: red;\n}\n\n::ng-deep .head-properties .mat-form-field {\n  font-size: 20px;\n}\n::ng-deep .head-properties .mat-form-field mat-error div {\n  width: auto;\n  border-style: solid;\n  border-radius: 5px;\n  background: #b71c1c;\n  color: white;\n  margin-top: 4px;\n}\n\ninput.mat-input-element {\n  color: gray;\n  font-weight: normal;\n}\n\nfieldset {\n  width: 99.3%;\n}\nfieldset .mat-radio-label {\n  color: grey;\n}\nfieldset span p {\n  margin: 5px 10px 4px 10px;\n}\nfieldset legend {\n  font-size: 11px;\n}\n\n.choice-control-properties,\n.radio-control-properties,\n.textbox-control-properties,\n.number-control-properties,\n.date-control-properties,\n.email-control-properties,\n.website-control-properties,\n.phone-control-properties,\n.currency-control-properties,\n.signature-control-properties,\n.name-control-properties,\n.address-control-properties,\n.upload-control-properties {\n  display: flex;\n  flex-direction: column;\n}\n\n.type-radio {\n  display: flex;\n  font-size: 14px;\n  flex-direction: column;\n}\n.type-radio .mat-radio-button {\n  margin: 0px 0px 5px 5px;\n}\n.type-radio .mat-radio-button:last-child {\n  margin-bottom: 0px !important;\n}\n\n.field-set-type, .field-set-type-options {\n  border: 1px solid rgb(211, 211, 211);\n  font-size: 14px;\n  border-radius: 5px;\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 5px;\n}\n.field-set-type legend, .field-set-type-options legend {\n  font-weight: bold;\n  color: gray;\n}\n.field-set-type span, .field-set-type-options span {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  word-break: break-all;\n}\n\n.eform-btn-actions {\n  border-radius: 5px;\n}\n\n.eform-btn-actions-first {\n  border-radius: 5px 0px 0px 5px;\n}\n\n.eform-btn-actions-mid {\n  border-radius: 0px 0px 0px 0px;\n}\n\n.eform-btn-actions-last {\n  border-radius: 0px 5px 5px 0px;\n}\n\n.field-option {\n  width: 255px;\n}\n\n.field-set {\n  border-color: red;\n}\n\n.margin-left-5 {\n  margin-left: 5px;\n}\n\n.margin-left-10 {\n  margin-left: 10px;\n}\n\n.margin-left-15 {\n  margin-left: 15px;\n}\n\n.margin-left-25 {\n  margin-left: 25px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
